module.exports = __webpack_public_path__ + "static/media/banner.fc0f25f1.svg";